import React from "react";
import { useState } from "react";
import EmployeeInfo from "../Cards/EmployeeInfo";
import ApprovalStatus from "./Components/approvalStatus";
import ViewApproval from "./ViewApproval";
import moment from "moment";
import { TbBed, TbBus, TbCar, TbMap, TbPlane, TbReceipt, TbTrain } from "react-icons/tb";
import { useClientSettings } from "Hooks/useClientSettings";

function Approvals({ id, status, amount, type, date, trail, inSequence, violations, requestor, approvers, onReload = () => {}, readOnly }) {
	const { currency } = useClientSettings();

	const [OpenId, setOpenId] = useState();
	const ICONS = {
		trip: <TbMap />,
		receipt: <TbReceipt />,
		flight: <TbPlane />,
		bus: <TbBus />,
		stay: <TbBed />,
		train: <TbTrain />,
		cab: <TbCar />,
	};

	return (
		<>
			<div onClick={() => setOpenId(id)} className="w-full min-w-0 overflow-hidden border shadow-sm cursor-pointer rounded-xl bg-canvas hover:bg-light">
				<div className="p-4">
					{/* change start by cursor */}
					<div className="flex flex-wrap items-start justify-between gap-x-2 gap-y-1">
						<div className="flex min-w-0 flex-1 items-center gap-x-2">
							<span className="shrink-0">{ICONS[type]}</span>
							<h4 className="min-w-0 capitalize truncate">
								{type} - {currency} {amount}
							</h4>
						</div>
						<div className="text-label shrink-0 whitespace-nowrap">{moment(date).format("DD MMM YYYY")}</div>
					</div>
					{/* change end by cursor */}
					<EmployeeInfo size="sm" className="!p-0 mt-3 min-w-0" employee={requestor} />
				</div>
				{status && <ApprovalStatus status={status} id={`APP-${id}`} trail={trail} inSequence={inSequence} />}
			</div>
			<ViewApproval readOnly={readOnly} approvalId={OpenId} onClose={() => setOpenId()} onReload={onReload} />
		</>
	);
}

export default Approvals;
